import { cn } from "@/lib/utils";
import { FC } from "react";
import { NavLink } from "react-router-dom";

type NavigationItemSubtreeProps = {
  subtree?: Array<{
    label: string;
    href: string;
    disabled?: boolean;
    disabledReason?: string;
  }>;
};

const className =
  "inline-flex truncate rounded-sm py-1 pl-9 pr-3 text-sm font-bold text-[#9491CF] max-w-full w-full min-w-0";

const NavigationItemSubtree: FC<NavigationItemSubtreeProps> = (props) => {
  return (
    <>
      {(props.subtree?.length || 0) > 1 && (
        <ul className="mt-1">
          {props.subtree?.map((child) => (
            <li key={child.label} className="px-3">
              {child.disabled ? (
                <div className={cn(className, "cursor-not-allowed opacity-60")}>
                  {child.label}
                </div>
              ) : (
                <NavLink
                  className={({ isActive }) =>
                    cn(
                      className,
                      "hover:text-[#706da1]",
                      isActive && "bg-[#E3E3F3]",
                      child.disabled && "cursor-not-allowed opacity-60",
                    )
                  }
                  to={child.href}
                  title={child.disabled ? child.disabledReason : undefined}
                >
                  {child.label}
                </NavLink>
              )}
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default NavigationItemSubtree;
